import { FINANCIAL_CONSTANTS } from '../../../utils/helper';
import { getCareerShiftRunwayData } from '../../../utils/onboardingUtils';

export function getTimeOfDayGreeting() {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 17) return 'Good afternoon';
  return 'Good evening';
}

export function formatTodayChip(now = new Date()) {
  const day = now.getDate();
  const month = now.toLocaleString('en-GB', { month: 'short' });
  const year = now.getFullYear();
  return `Today, ${day} ${month} ${year}`;
}

export function buildForecastHeroSubtitle(onboardingProgress) {
  if (!onboardingProgress) {
    return "Keep going, you're doing great!";
  }
  const runway = getCareerShiftRunwayData(onboardingProgress);
  if (runway.runwayValue === FINANCIAL_CONSTANTS.FULLY_COVERED) {
    return "You have full financial flexibility for your career shift. Keep going, you're doing great!";
  }
  const monthsLabel = runway.runwayDisplayValue || `${runway.runwayValue} months`;
  return `You have ${monthsLabel} of financial flexibility for your career shift. Keep going, you're doing great!`;
}
